export enum SmsStatuses {
  Failed = 'failed',
  Received = 'received',
  Queued = 'queued',
  Delivered = 'delivered',
  Undelivered = 'undelivered',
  Sent = 'sent',
}
